import {Nullable} from '../types'

export function cleanArray<T>(array: Array<Nullable<T>>): Array<T> {
  return array.filter(Boolean) as Array<T>
}

export function intersectionSets<T>(...sets: Set<T>[]): Set<T> {
  let resultSet: Set<T> = new Set<T>(Array.from(sets[0]))
  for (let i = 1; i < sets.length; i++) {
    if (resultSet.size === 0) {
      break
    }
    // eslint-disable-next-line no-loop-func
    resultSet = new Set(Array.from(sets[i]).filter(x => resultSet.has(x)))
  }
  return resultSet
}

export function intersectionArrays<T>(...arrays: Array<T>[]): Array<T> {
  let resultSet: Set<T> = new Set<T>(arrays[0])
  for (let i = 1; i < arrays.length; i++) {
    if (resultSet.size === 0) {
      break
    }
    // eslint-disable-next-line no-loop-func
    resultSet = new Set(arrays[i].filter(x => resultSet.has(x)))
  }
  return Array.from(resultSet)
}

export function differenceArrays<T>(first: Array<T>, second: Array<T>): Array<T> {
  const deductibleSet = new Set(second)
  return first.filter(x => !deductibleSet.has(x))
}